<template>
  <div class="container-fluid h-100 reservation-create__container">
    <div class="col-md-12 py-5 h-100">
      <div class="row py-5 justify-content-center d-flex h-100 align-items-center">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title"></h5>
            </div>
            <div class="card-body">
              <div class="container">
                  <div>
                    <label class="typo__label font-weight-bold">Organisatie</label>
                    <multiselect 
                    :options="organizations" 
                    :loading="loadingOrganizations"
                    label="name" 
                    placeholder="Selecteer een Organisatie"
                    v-model="selectedOrganization" 
                    track-by="name">
                    </multiselect>
                    <label
                    class="typo__label font-weight-bold" 
                    v-if="departments.length > 0">Afdelingen</label>
                    <multiselect 
                    :options="departments" 
                    :loading="loadingDepartments"
                    v-if="departments.length > 0"
                    label="name" 
                    placeholder="Selecteer een Afdeling"
                    v-model="selectedDepartment" 
                    track-by="name">
                    </multiselect>
                    <p class="text-danger" v-if="noDepartmentSelectedMessage">Er moet een afdeling geselecteerd worden.</p>
                  </div>
                <div class="date formulate-input mb-1">
                  <FormulateForm
                    v-model="formValues"
                    v-if="formValues"
                  >
                    <div class="row mt-3 d-flex flex-row">
                      <div class="col-md-6">
                        <p class="font-weight-bold w-100 mb-1">Kortingscode</p>
                        <FormulateInput
                          type="text"
                          name="discountCode"
                          placeholder="Kortingscode"
                          autocomplete="discount-code"
                        />
                      </div>
                      <div class="col-md-6" v-if="paymentMethods">
                        <p class="font-weight-bold w-100 mb-1">Betaalmethode</p>
                        <div v-if="(selectedOrganization !== null && typeof selectedOrganization === 'object' && selectedOrganization.hasOwnProperty('id')) ? true : false">
                          <FormulateInput
                            v-model="paymentMethod"
                            :options="otherPaymentMethods ? {'factuur': 'Op factuur', 'ideal': paymentMethods.ideal.description, 'creditcard': `${paymentMethods.creditcard.description}`, 'contant': 'Contant betalen bij aflevering', 'pin': 'Pinnen bij aflevering'} : {'factuur': 'Op factuur'}"
                            type="radio"
                            name="paymentMethod"
                          />
                          <FormulateInput
                            label="Andere betaalmethode"
                            type="checkbox"
                            name="otherPaymentMethods"
                            v-model="otherPaymentMethods"
                          />
                        </div>
                        <div v-else>
                          <FormulateInput
                            v-model="paymentMethod"
                            :options="{'ideal': paymentMethods.ideal.description, 'creditcard': `${paymentMethods.creditcard.description}`, 'contant': 'Contant betalen bij aflevering', 'pin': 'Pinnen bij aflevering'}"
                            type="radio"
                            name="paymentMethod"
                          />
                        </div>
                        
                        <div
                          v-if="paymentMethod === 'ideal'">
                          <p class="font-weight-bold w-100 mb-1">Bank</p>
                          <multiselect v-model="idealIssuer" track-by="name" :options="paymentMethods.ideal.issuers" :custom-label="customLabel" :show-labels="false">
                            <template slot="singleLabel" slot-scope="props"><div class="d-flex h-100 align-items-center">
                              <img class="h-100" :src="props.option.image.size1x"><p class="h-100 ml-2 mb-0">{{ props.option.name }}</p>
                            </div></template>
                            <template slot="option" slot-scope="props"><div class="d-flex h-100 align-items-center">
                              <img class="h-100" :src="props.option.image.size1x"><p class="h-100 ml-2 mb-0">{{ props.option.name }}</p>
                            </div>
<!--                              <div class="option__desc"><span class="option__title"></span></div>-->
                            </template>
                          </multiselect>
                        </div>

                      </div>
                      
                    </div>
                  </FormulateForm>
                </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-between text-muted align-items-center">
              <router-link :to="{ name: 'newReservation'}"><small class="d-flex"><i class="gg-arrow-left"></i>vorige stap</small></router-link>
              <div class="d-flex align-items-center">
                <a-checkbox class="ml-2" v-model="sendMailToClient">
                  Verstuur mail naar klant
                </a-checkbox>
                <p class="mb-0 font-weight-bold mx-3">
                {{price | currency}}
              </p>
              <button type="button" class="btn btn-primary" @click="submitInfo">Reserveer</button>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import _debounce from 'lodash/fp/debounce';

    export default {
        computed: {
            reservation: {
                get: function () {
                    return this.$store.state.reservation
                },
                // setter
                set: function (newValue) {
                }
            },
            date: {
                get: function () {
                    return this.$store.state.reservation.date
                },
                // setter
                set: function (newValue) {
                    this.$store.commit('reservation/addDate', newValue)
                }
            },
            formValues: {
                get: function () {
                    return this.$store.state.reservation.info
                },
                // setter
                set: function (newValue) {
                    console.log(newValue);
                    this.$store.commit('reservation/add', newValue)
                    this.fetchPrice();
                }
            },
            idealIssuer: {
                get: function () {
                    return this.$store.state.reservation.info.issuer
                },
                // setter
                set: function (newValue) {
                    console.log('idealIssuer', newValue);
                    this.$store.commit('reservation/addIssuer', newValue)
                    this.fetchPrice();
                }
            },
            user: {
              get: function () {
                return this.$store.state.user
              },
            },
        },
        watch: {
            licensePlate(){
                this.getLicenseplate()
            },
            formValues(newVal){
                // API /price/
                console.log(newVal);
            },
            selectedOrganization(newVal){
              this.otherPaymentMethods = false;
              this.paymentMethod = undefined;
              this.departments = [];
              
              this.selectedDepartment = undefined;
              
              this.fetchPrice();
              if(newVal !== null){
                this.fetchDepartments();
              }
            },
            selectedDepartment(newVal){
              this.fetchPrice();
            }
        },
        data() {
            return {
                loadingOrganizations: true,
                loadingDepartments: true,
                price: undefined,
                licensePlate: undefined,
                paymentMethod: undefined,
                paymentMethods: undefined,
                organizations: [],
                departments: [],
                selectedOrganization: undefined,
                selectedDepartment: undefined,
                otherPaymentMethods: false,
                noDepartmentSelectedMessage: false,
                sendMailToClient: true,
            }
        },
        beforeMount(){
            if(!this.date.start && !this.date.end){
                this.$store.commit('reservation/addDate', {
                    start: this.$moment().add(0, 'days').toDate(), // Jan 16th, 2018
                    end: this.$moment().add(7, 'days').toDate()    // Jan 19th, 2018
                })
            }
            this.$axios.get('reservations/getOrganizations', {headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }}).then(response => {
              this.organizations = response.data;
              this.loadingOrganizations = false;
          });
            this.fetchPaymentMethods();
        },
        mounted(){
            this.fetchPrice();
        },
        methods: {
            fetchDepartments(){
              this.loadingDepartments = true;
              this.$axios.get('reservations/getDepartmentsByOrganizationId', {
                params: {
                  organization_id: this.selectedOrganization.id
                },
              headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }}).then(response => {
              this.departments = response.data;
              this.loadingDepartments = false;
          });
            },
            submitInfo(data) {
                if(this.departments.length > 0 && this.selectedDepartment === undefined){
                  this.noDepartmentSelectedMessage = true;
                  return;
                }else{
                  this.noDepartmentSelectedMessage = false;
                }
                let fullReservation = JSON.parse(JSON.stringify(this.reservation));
                if(fullReservation.info.paymentMethod === ""){
                  this.$message.error('Er is geen betaalmethode geselecteerd.');
                  return false;
                }
                fullReservation.date.start = `${this.$moment(fullReservation.date.start).format('YYYY-MM-DD')} ${fullReservation.dropoffTime}:00`;
                fullReservation.date.end = `${this.$moment(fullReservation.date.end).format('YYYY-MM-DD')} ${fullReservation.pickupTime}:00`;
                this.$axios.post('reservations/admin', {
                  organization_id: (typeof this.selectedOrganization === 'object') ? this.selectedOrganization.id : null, 
                  department_id: (typeof this.selectedDepartment === 'object') ? this.selectedDepartment.id : null, 
                  sendMailToClient: this.sendMailToClient,
                    ...fullReservation
                }, {
                  headers: {
                    'Authorization': `Bearer ${this.user.user.token}`,
                  }
                }).then(response => {
                    if(response.data.status === '200'){
                        window.location.href = response.data.redirect_uri
                    }
                })
            },
            fetchPrice: _debounce(500, function() {
                let fullReservation = JSON.parse(JSON.stringify(this.reservation));
                fullReservation.organization_id = (this.selectedOrganization !== null && typeof this.selectedOrganization === 'object') ? this.selectedOrganization.id : null;
                fullReservation.date.start = `${this.$moment(fullReservation.date.start).format('YYYY-MM-DD')} ${fullReservation.dropoffTime}:00`;
                fullReservation.date.end = `${this.$moment(fullReservation.date.end).format('YYYY-MM-DD')} ${fullReservation.pickupTime}:00`;
                this.$axios.post('reservations/price', {
                    ...fullReservation
                }).then((response)=>{
                    this.price = response.data.price
                })
            }),
            fetchPaymentMethods() {
                this.$axios.get('payment-methods', {params: {
                    organization_id: (typeof this.selectedOrganization === 'object') ? this.selectedOrganization.id : null,
                }}).then((response)=>{
                    this.paymentMethods = response.data;
                    if(response.data.hasOwnProperty('ideal')){
                      this.idealIssuer = response.data.ideal.issuers[0];
                    }
                    
                })
            },
            customLabel ({ name, image }) {
                return `${name}<img src="${image.size1x}" />`
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  /*@import '~vue2-timepicker/dist/VueTimepicker.css';*/
  .gg-arrow-left{
    --ggs: 0.6;
  }
  .reservation-create__container{
    background-size: cover;
    background-position: center;
    // background-image: url('~assets/img/schiphol.jpg')
  }
  .card{
    h5{
      font-weight: 500;
    }
    .btn{
      font-weight: 500;
      font-family: 'Work Sans', sans-serif;
    }
  }
</style>
